import React from 'react';
import color from 'src/styles/themes/color';

type Props = {
  w?: number;
  h?: number;
  fill?: string;
  className?: string;
  onClick?: () => void;
};

const IconChevronLeft: React.FC<Props> = ({
  w = 16,
  h = 17,
  fill = color.neutral_7,
  className,
  onClick,
}) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_14125_18529)">
        <path
          d="M10.666 11.7985L9.72321 12.7435L5.00916 8.01869L9.72321 3.29391L10.666 4.23887L6.89478 8.01869L10.666 11.7985Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_14125_18529">
          <rect
            width="16"
            height="16.0364"
            fill="white"
            transform="translate(16 16.0364) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconChevronLeft;
